type Props = {
  current: number
  total: number
}

export const ImageCounter: React.FC<Props> = ({ current, total }) => (
  <div className="flex items-center space-x-[6px] rounded-[50px] bg-black/50 px-[11px] py-1 text-[12px] text-white">
    <span>{current}</span>
    <span className="h-3 w-[1px] bg-white/40" />
    <span>{total}</span>
  </div>
)
